var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentCreatorVideo?.user)?_c('b-btn',{staticClass:"action-button my-2 opacity-100"},[_c('user-round-avatar',{attrs:{"standardMap":_vm.currentCreatorVideo.user,"nonPrimaryPhotos":false,"hideBadges":true,"userBetweenStatus":false,"size":"small"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }